export const FILTERS = {
    pending: {
        key: 'lead_status_dropdown_option_id',
        value: 'lead_status_pending'
    },
    pending_verification: {
        key: 'lead_status_dropdown_option_id',
        value: 'lead_status_pending_verification'
    },
    pending_manual_verification: {
        key: 'lead_status_dropdown_option_id',
        value: 'lead_status_manual_verif_required'
    },
    pending_approval: {
        key: 'lead_status_dropdown_option_id',
        value: 'lead_status_pending_approval'
    },
    payment_missed: {
        key: 'loan_status_dropdown_option_id',
        value: 'loan_status_payment_missed'
    },
    pending_void: {
        key: 'loan_status_dropdown_option_id',
        value: 'loan_status_pending_void'
    },
    pending_cancellation: {
        key: 'loan_status_dropdown_option_id',
        value: 'loan_status_pending_cancellation'
    },
    pending_early_payoff: {
        key: 'loan_status_dropdown_option_id',
        value: 'loan_status_pending_early_payoff'
    },
    in_queue: {
        key: 'payment_status_dropdown_option_id',
        value: 'payment_status_in_queue'
    },
    in_process: {
        key: 'payment_status_dropdown_option_id',
        value: 'payment_status_in_process'
    },
    returned: {
        key: 'payment_status_dropdown_option_id',
        value: 'payment_status_returned'
    },
    error_processing: {
        key: 'payment_status_dropdown_option_id',
        value: 'payment_status_error'
    },
    c_code_paid: {
        key: 'payment_status_dropdown_option_id',
        value: 'payment_status_c_code_paid'
    },
    hold: {
        key: 'payment_status_dropdown_option_id',
        value: 'payment_status_hold'
    },
    current_lead: {
        key: 'customer_status_dropdown_option_id',
        value: 'customer_status_current_lead'
    },
    current_loan: {
        key: 'customer_status_dropdown_option_id',
        value: 'customer_status_current_loan'
    },
    unscheduled_balance: {
        key: 'loan_sub_status_dropdown_option_id',
        value: 'loan_sub_status_no_repay'
    },
    fundable: {
        key: 'customer_status_dropdown_option_id',
        value: 'customer_status_fundable'
    },
    non_fundable: {
        key: 'customer_status_dropdown_option_id',
        value: 'customer_status_nonfundable'
    },
    payment_correction: {
        key: 'payment_correction',
        value: '1'
    },
    approval_required: {
        key: 'mgr_approval_status_dropdown_option_id',
        value: 'mgr_approval_status_required'
    },
}
